/**
 * Resources
 * **/

const resources = [{
  title: 'MS Office Ribbon Component for VueJs',
  description: 'JavaScript, CSS3 and HTML5 implementation of the Microsoft Office ribbon control, built on top of VueJs and ES6',
  url: 'https://vueribbon.com'
}, {
  title: 'Vuecidity UI Library',
  description: 'Vuecidity is a free, open source and licensed under MIT component library for the Vue.js framework, inspired by Google Material Design and Bootstrap',
  url: 'https://vuecidity.wemakesites.net'
}, {
  title: 'Guitar Chord Diagram',
  description: 'VcChordDiagram is an open source guitar chord diagram generator for VueJs',
  url: 'https://vc-chord-diagram.wemakesites.net'
}, {
  title: 'Icons.IO',
  description: 'Search, preview and use thousands of icons from Google Material Design, Font Awesome, Weather Icons, Ionic, Emoji CSS, Government Icons and more, ready for VueJs, Angular, React or native apps',
  url: 'https://icons.wemakesites.net'
}, {
  title: 'CSS Gradients',
  description: 'CSS gradients generator built on top of VueJs and Vuecidity',
  url: 'https://gradients.wemakesites.net'
}, {
  title: 'MS Office Ribbon Component for jQuery',
  description: 'Ribbon JS is arguably the best recreation of the MS Office ribbon bar, using JavaScript, CSS3, and HTML5.',
  url: 'http://ribbonjs.com/'
}, {
  title: 'My Blog',
  description: 'My personal blog about web development and music',
  url: 'https://martinivanov.net'
}, {
  title: 'My Portfolio',
  description: 'My portfolio and professional website',
  url: 'https://wemakesites.net'
}]

export default resources



// WEBPACK FOOTER //
// ./src/helpers/resources.js